import ttt from '@xingternal/ticktricktrack';

const hostname =
  (globalThis.location && globalThis.location.hostname) || 'default';

const envs: Record<string, string> = {
  localhost: 'development',
  'lebenslauf.com': 'production',
  'www.xing.com': 'production',
  default: 'preview',
};

const env = envs[hostname] || envs['default'];

export const initTracking = (): typeof ttt => {
  ttt.init(env, { fetchTrackingData: true });
  return ttt;
};
